import React from 'react';
import Rating from '@mui/material/Rating';
import { Avatar } from '@mui/material';

import { useSelector } from 'react-redux';
import StyledButton from '../../../../../shared/components/styledButton/styledButton';
import i18n from '../../../../../utils/i18n';
import shieldCheck from '../../../../../images/shield-check.png';

const SelectedCardContentMobile = ({ data, setOpen, ...props }) => {
	const companyStore = useSelector((state) => state.company_store);
	// console.log("MOBILE REQ ID", props.reqID);
	return (
		<div className="Mobile">
			<div className="ProviderCardSection">
				<div className="ProviderCardHeader">
					<Avatar
						src={data.providerImage}
						style={{ width: '48px', height: '48px' }}
					/>
					<div>
						<p className="ProvHeaderTexts">
							<span style={{ fontSize: '16px' }} className="Bold">
								{data.providerName}
							</span>
							<span>
								<Rating
									name="half-rating-read"
									defaultValue={data.providerReview}
									precision={0.1}
									readOnly
									size="medium"
								/>
							</span>
						</p>
						<p>
							{data.packageType === 'premium'
								? i18n.t('general.certifiedaccountant')
								: i18n.t('general.accountant')}
						</p>
					</div>
					{data.packageType === 'premium' && (
						<img className="shieldCheck" alt="shieldCheck" src={shieldCheck} />
					)}
				</div>
				<div
					style={{
						width: '100%',
						display: 'flex',
						justifyContent: 'space-evenly',
					}}>
					{data.insurrance === 'none' ? null : (
						<span className="badgecontainer">
							{i18n.t('searchflow.sfpreftext7')}
						</span>
					)}
					{data.digitalBadge !== 'none' && data.digitalBadge !== 'tbd' ? (
						<span className="badgecontainer">
							{i18n.t('searchflow.sfpreftext5')}
						</span>
					) : null}
					<span className="badgecontainer">
						{i18n.t('general.matchscore')}:{' '}
						<span className="ScoreStyle">{data.totalmatchscore}</span>
					</span>
				</div>
				<hr style={{ margin: '8px 0px !important' }} />
			</div>
			<div
				className="ProviderCardSection"
				style={{
					alignItems: 'space-between',
				}}>
				<div className="ProviderCardScores">
					<p>
						<span>{`${i18n.t('general.pricemonthly')}: `}</span>
						<span className="">{`${data.proposedContPrice} ${i18n.t(
							'general.currency'
						)}`}</span>
					</p>

					<p>
						<span>{`${i18n.t('general.pricecalculation')}: `}</span>
						<span className="">{`${data.proposedSinglePrice} ${i18n.t(
							'general.currency'
						)}`}</span>
					</p>
				</div>
				<hr style={{ margin: '8px 0px !important' }} />
				<div
					style={{
						marginTop: '8px',
						display: 'flex',
						justifyContent: 'flex-end',
					}}>
					<StyledButton
						onClick={(e) => {
							e.stopPropagation();
							setOpen(true);
						}}
						color={
							companyStore.selected_providers.find(
								({ providerID }) => providerID === data.providerID
							) && props.reqID?.length > 0
								? 'Success'
								: 'NewReqBtn'
						}
						isDisabled={
							companyStore.selected_providers.find(
								({ providerID }) => providerID === data.providerID
							) && props.reqID?.length > 0
						}>
						{i18n.t('searchflow.reqmsgtitle')}
					</StyledButton>
				</div>
			</div>
		</div>
	);
};

export default SelectedCardContentMobile;
